import { createAction } from '@reduxjs/toolkit';
import { Subscription } from '../../entities';

export const enableUserSubscription = createAction('user/ENABLE_USER_SUBSCRIPTION');
export const updateSubscriptions = createAction<Array<Subscription>>('user/UPDATE_SUBSCRIPTIONS');
